<template>
  <el-select size="small" popper-class="condition_popper_select" v-model="selectValue" style="width: 120px">
    <el-option v-for="opt of typeSelectOptions" :key="opt.value" :label="opt.label" :value="opt.value">{{ opt.label }}</el-option>
  </el-select>
</template>

<script>
import { selectValueMixins } from './mixins'

export default {
  name: 'ConditionTypeSelect',
  mixins: [selectValueMixins],
  data() {
    return {
      // options: [
      //   { label: '基础信息', value: '0' },
      //   { label: '调查员属性', value: '1' },
      //   { label: '题目', value: '3' },
      //   // { label: '自定义属性', value: '2'},
      // ]
    }
  }
}
</script>
